import { useQueryClient } from "@tanstack/react-query";

import { $api } from "@/shared/api";

import { patchHighlights } from "./patchHighlights";

// «Создать ссылку» (`POST /api/highlights/{id}/share`): у клипа появляется публичная
// страница `relock.gg/c/<код>`. Повтор отдаёт тот же код.
export const useShareClip = () => {
  const queryClient = useQueryClient();
  const mutation = $api.useMutation("post", "/api/highlights/{highlight_id}/share", {
    onSuccess: (view) => {
      patchHighlights(queryClient, [view]);
    },
  });
  const share = (highlightId: number) => {
    mutation.mutate({ params: { path: { highlight_id: highlightId } } });
  };
  return { ...mutation, share };
};
